import { render, staticRenderFns } from "./Consult.vue?vue&type=template&id=56e08ffe"
import script from "./Consult.vue?vue&type=script&lang=js"
export * from "./Consult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports